<template>
  <div id="socials"
    class="relative overflow-hidden pt-[180px] pb-[171px] md:pt-[241px] md:pb-[158px] bg-gradient-to-r from-[#747CD7] via-[#747CD7] to-[#747CD7] ">

    <img src="../assets/circle.png" alt="Circle 1"
      class="absolute top-[30px] -left-[100px] w-[300px] h-[300px] rounded-full object-contain">
    <img src="../assets/circle.png" alt="Circle 2"
      class="absolute top-[400px] md:top-[360px] -right-[50px] md:-right-[10px] w-[220px] h-[220px] md:w-[320px] md:h-[320px] rounded-full object-contain">

    <div
      class="absolute top-[200px] -left-[140px] w-full h-full md:w-[400px] md:h-[400px] rounded-full md:bg-white bg-[#F25960] opacity-10 blur-2xl">
    </div>
    <div
      class="absolute top-[200px] -right-[140px] w-full h-full md:w-[400px] md:h-[400px] rounded-full md:bg-white bg-[#F25960] opacity-10 blur-2xl">
    </div>

    <div class="text-[32px] md:text-7xl lg:text-4xl text-white leading-10 font-black text-center font-montserrat">
      <span style="text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);" class="text-[#97FF82]"> FOLLOW ME</span> ON MY SOCIALS
    </div>

    <div class="flex flex-wrap flex-row justify-center gap-[10px] sm:gap-[20px] md:gap-[40px] mt-[40px] sm:mt-[70px]">
      <!-- YouTube Button -->
      <a v-motion-slide-visible-bottom href="https://www.youtube.com/@HanveeStreamer" target="_blank"
        class="p-[2px] rounded-full sm:h-[120px] sm:w-[120px] h-[100px] w-[100px] md:h-[200px] md:w-[200px] hover:cursor-pointer relative">
        <img src="../assets/social-button.png" alt="youtube button" class="object-cover w-full h-full rounded-full"
          style="filter: drop-shadow(6px 11px 17px rgba(14, 17, 36, 0.55));" />
        <div class="absolute inset-0 flex items-center justify-center ">
          <img src="../assets/youtube.png" class="object-contain w-8 h-8 sm:w-8 sm:h-8 md:w-14 md:h-14 "
            alt="youtube" />
        </div>
      </a>

      <!-- X Button -->
      <a v-motion-slide-visible-bottom href="https://x.com/hanveestake" target="_blank"
        class="p-[2px] rounded-full sm:h-[120px] sm:w-[120px] h-[100px] w-[100px] md:h-[200px] md:w-[200px] hover:cursor-pointer relative">
        <img src="../assets/social-button.png" alt="x button" class="object-cover w-full h-full rounded-full"
          style="filter: drop-shadow(6px 11px 17px rgba(14, 17, 36, 0.55));" />
        <div class="absolute inset-0 flex items-center justify-center">
          <img src="../assets/X.png" class="object-contain w-8 h-8 sm:w-8 sm:h-8 md:w-14 md:h-14" alt="X" />
        </div>
      </a>

      <!-- Discord Button -->
      <a v-motion-slide-visible-bottom href="https://discord.gg/zQ5cGPBuj8" target="_blank"
        class="p-[2px] rounded-full sm:h-[120px] sm:w-[120px] h-[100px] w-[100px] md:h-[200px] md:w-[200px] hover:cursor-pointer relative">
        <img src="../assets/social-button.png" alt="discord button" class="object-cover w-full h-full rounded-full"
          style="filter: drop-shadow(6px 11px 17px rgba(14, 17, 36, 0.55));" />
        <div class="absolute inset-0 flex items-center justify-center">
          <img src="../assets/discord.png" class="object-contain w-8 h-8 sm:w-8 sm:h-8 md:w-14 md:h-14"
            alt="discord" />
        </div>
      </a>

      <!-- Kick Button -->
      <a v-motion-slide-visible-bottom href="https://kick.com/hanvee" target="_blank"
        class="p-[2px] rounded-full sm:h-[120px] sm:w-[120px] h-[100px] w-[100px] md:h-[200px] md:w-[200px] hover:cursor-pointer relative">
        <img src="../assets/social-button.png" alt="kick button" class="object-cover w-full h-full rounded-full"
          style="filter: drop-shadow(6px 11px 17px rgba(14, 17, 36, 0.55));" />
        <div class="absolute inset-0 flex items-center justify-center">
          <img src="../assets/kick.png" class="object-contain w-8 h-8 sm:w-8 sm:h-8 md:w-14 md:h-14" alt="kick" />
        </div>
      </a>

      <!-- Telegram Button -->
      <a v-motion-slide-visible-bottom href="https://t.me/hanveechannel" target="_blank"
        class="p-[2px] rounded-full sm:h-[120px] sm:w-[120px] h-[100px] w-[100px] md:h-[200px] md:w-[200px] hover:cursor-pointer relative">
        <img src="../assets/social-button.png" alt="telegram button" class="object-cover w-full h-full rounded-full"
          style="filter: drop-shadow(6px 11px 17px rgba(14, 17, 36, 0.55));" />
        <div class="absolute inset-0 flex items-center justify-center">
          <img src="../assets/telegram.png" class="object-contain w-8 h-8 sm:w-8 sm:h-8 md:w-14 md:h-14"
            alt="telegram" />
        </div>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: "SocialSection",
};
</script>
